export default __webpack_public_path__ + "static/media/natoursApp.1c186348.jpg";